function toISODateLocal(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

function intersectSets(sets) {
  if (!sets.length) return null;
  let result = new Set(sets[0]);
  for (let i = 1; i < sets.length; i++) {
    const s = new Set(sets[i]);
    result = new Set([...result].filter(x => s.has(x)));
  }
  return result;
}

function readCartAllowedDatesIntersection() {
  const el = document.getElementById("pickup-cart-restrictions-json");
  if (!el) return null;

  let data;
  try {
    data = JSON.parse(el.textContent || "{}");
  } catch (e) {
    console.warn("[Pickup] pickup-cart-restrictions-json invalid", e);
    return null;
  }

  const restricted = Array.isArray(data.restricted) ? data.restricted : [];
  const lists = restricted
    .map(r => Array.isArray(r.dates) ? r.dates : [])
    .filter(arr => arr.length > 0);

  // Wenn keine Produkte Einschränkungen haben → keine Einschränkung
  if (!lists.length) return null;

  // Intersection: Datum muss für ALLE eingeschränkten Produkte passen
  return intersectSets(lists);
}



document.addEventListener('DOMContentLoaded', function () {
  // Flatpickr verfügbar?
  if (typeof flatpickr === 'undefined') return;

  const dateInput = document.getElementById('pickup-date');
  const locationSelect = document.getElementById('pickup-location');
  const locationsScript =
  document.getElementById('pickup-locations-json') ||
  document.getElementById('pickup-location-json') ||
  document.getElementById('pickupLocationsJson');
  const pickupLocationNote = document.getElementById('pickup-location-note');

  if (!dateInput || !locationSelect || !locationsScript) return;

  // -----------------------------
  // Filial-Konfiguration lesen
  // -----------------------------
  let config = {};
  try {
    config = JSON.parse(locationsScript.textContent || '{}');
  } catch (e) {
    console.error('Fehler beim Parsen von pickup-locations-json:', e);
    return;
  }

  
const allowedLocationIds =
  readCartAllowedLocationsIntersection();

const locations = (config.locations || []).filter(loc => {
  return (
    allowedLocationIds === null ||
    allowedLocationIds.has(String(loc.id))
  );
});


  // -----------------------------
  // Hilfsfunktionen
  // -----------------------------
  function addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  function formatDate(date) {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  // Produkte mit allowed_pickup_dates
  function getRestrictedProducts() {
    const items = document.querySelectorAll('.cart-item[data-allowed-dates]');
    const restricted = [];
    items.forEach((item) => {
      const title = item.dataset.productTitle || 'Dieses Produkt';
      let allowedDates = [];
      try {
        allowedDates = JSON.parse(item.dataset.allowedDates || '[]');
      } catch (e) {
        console.warn('Fehler beim Parsen von allowedDates für', title, e);
      }
      restricted.push({ title, allowedDates });
    });
    return restricted;
  }

  const restrictedProducts = getRestrictedProducts();

  const today = new Date();
  const minOffsetDays = 4;   // z.B. 4 Tage Vorlauf
  const maxOffsetDays = 60;  // max 60 Tage in der Zukunft

  const minDate = addDays(today, minOffsetDays);
  const maxDate = addDays(today, minOffsetDays + maxOffsetDays);

  // -----------------------------
  // Erlaubte Tage für eine Filiale
  // -----------------------------
  function getAllowedDatesForLocation(locationId) {
    const allowed = [];
    const loc = locations.find((l) => l.id === locationId);
    if (!loc) return allowed;

    for (let i = 0; i < maxOffsetDays; i++) {
      const date = addDays(today, minOffsetDays + i);
      const dateStr = formatDate(date);

      // 1) Öffnungstage & geschlossene Sondertage
      const weekday = date.getDay(); // 0=So
      const openWeekdays = loc.weekday_open || [];
      const closedDates = loc.closed_dates || [];

      const isOpenWeekday = openWeekdays.includes(weekday);
      const isClosedSpecial = closedDates.includes(dateStr);

      if (!isOpenWeekday || isClosedSpecial) continue;

      // 2) Produktspezifische allowedDates (z.B. 2-Tages-Artikel)
      let blockedByProduct = false;
      restrictedProducts.forEach((prod) => {
        if (!prod.allowedDates || !prod.allowedDates.length) return;
        if (!prod.allowedDates.includes(dateStr)) {
          blockedByProduct = true;
        }
      });

      if (blockedByProduct) continue;

      allowed.push(dateStr);
    }

    return allowed;
  }

  // -----------------------------
  // Flatpickr-Instanz
  // -----------------------------
  let fpInstance = null;

  
function initFlatpickr(allowedDates, locationSelected = false) {
  if (fpInstance) {
    fpInstance.destroy();
  }

  const options = {
    dateFormat: 'Y-m-d',
    locale: flatpickr.l10ns.de,
    disableMobile: true,
    allowInput: false,
    minDate: formatDate(minDate),
    maxDate: formatDate(maxDate)
  };

  if (locationSelected) {
  if (allowedDates && allowedDates.length > 0) {
    options.enable = allowedDates;
  } else {
    // Ohne verfügbare Termine alle Tage sperren
    options.disable = [() => true];
  }
}

  fpInstance = flatpickr(dateInput, options);
}



  // -----------------------------
  // Filialbeschränkungen auslesen
  // -----------------------------
  function readCartAllowedLocationsIntersection() {
    const items = document.querySelectorAll(
      '.cart-item[data-allowed-pickup-locations]'
    );

    if (!items.length) return null;

    const lists = [];

    items.forEach(item => {
      try {
        const parsed = JSON.parse(
          item.getAttribute('data-allowed-pickup-locations') || '[]'
        );

        if (Array.isArray(parsed)) {
          lists.push(parsed.map(id => String(id).trim()));
        } else {
          lists.push([]);
        }
      } catch (e) {
        console.warn(
          '[Pickup] Fehler bei erlaubten Abholfilialen:',
          e
        );
        lists.push([]);
      }
    });

    return intersectSets(lists);
  }

  // -----------------------------
  // Initial: vorhandene Filiale
  // -----------------------------
  let currentLocationId =
    locationSelect.dataset.selectedLocation || '';

  if (currentLocationId) {
    const allowedDates =
      getAllowedDatesForLocation(currentLocationId);

    initFlatpickr(allowedDates, true);

    // Gespeichertes Datum überprüfen
    if (
      dateInput.value &&
      !allowedDates.includes(dateInput.value)
    ) {
      fpInstance.clear();
    }

    if (!allowedDates.length && pickupLocationNote) {
      pickupLocationNote.textContent =
        'Für diese Filiale sind aktuell keine Abholtermine verfügbar.';
    }
  } else {
    initFlatpickr([]);
  }

  // -----------------------------
  // Reaktion auf Filialwechsel
  // -----------------------------
  locationSelect.addEventListener('change', function () {
    currentLocationId = locationSelect.value || '';

    if (pickupLocationNote) {
      pickupLocationNote.textContent = '';
    }

    if (currentLocationId) {
      const allowedDates =
        getAllowedDatesForLocation(currentLocationId);

      initFlatpickr(allowedDates, true);

      // Ungültiges Datum zurücksetzen
      if (
        dateInput.value &&
        !allowedDates.includes(dateInput.value)
      ) {
        fpInstance.clear();
      }

      if (!allowedDates.length && pickupLocationNote) {
        pickupLocationNote.textContent =
          'Für die gewählte Filiale sind aktuell keine Abholtermine verfügbar. Bitte wähle eine andere Filiale oder kontaktiere uns.';
      }
    } else {
      initFlatpickr([]);
      dateInput.value = '';
    }
  });
});
